import MomentUtils from '@date-io/moment';
import {MenuItem, Select, TextField, Typography} from '@material-ui/core';
import {
  KeyboardDatePicker,
  MuiPickersUtilsProvider,
} from '@material-ui/pickers';
import React, {useEffect, useState} from 'react';
import {TFarmField} from '../models';
import {apiGETFARMFIELDS} from '../utils/graph';
import ButtonAddFees from './ButtonAddFees';
import {faTrash} from '@fortawesome/pro-solid-svg-icons';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {IGenericType} from 'constants/interfaces';

type ProductionPlanProps = {
  farmId: any;
  includeFundingInfo?: boolean;
  hectares?: string;
  estimatedYield?: string;
  irrigation?: IGenericType;
  startDate?: Date | null;
  supplyDate?: Date | null;
  farmFields?: Array<TFarmField>;
  onFarmFields?: (fields: Array<TFarmField>) => void;
  onHectares?: (hectares: string) => void;
  onEstimatedYield?: (estimatedYield: string) => void;
  onIrrigation?: (irrigation: IGenericType) => void;
  onStartDate?: (startDate: Date) => void;
  onSupplyDate?: (supplyDate: Date) => void;
};

const ProductionPlan = (props: ProductionPlanProps) => {
  const [farmFields, setFarmFields] = useState<Array<TFarmField>>([]);
  const [selectedFarmFields, setSelectedFarmFields] = useState<
    Array<TFarmField>
  >(props.farmFields || []);
  useEffect(() => {
    if (!props.includeFundingInfo) {
      apiGETFARMFIELDS(props.farmId).then((fields) => {
        setFarmFields(fields);
      });
    }
  }, [props.farmId]);
  useEffect(() => {
    props.onFarmFields?.(selectedFarmFields);
  }, [selectedFarmFields]);
  return (
    <div>
      <div className="title">Production plan</div>
      <MuiPickersUtilsProvider utils={MomentUtils}>
        <>
          <div className="row">
            <div className="col-6">
              <Typography>Hectares</Typography>
            </div>
            <div className="col-6">
              <TextField
                className="input"
                placeholder="Enter hectares"
                variant="outlined"
                fullWidth
                value={props.hectares}
                onChange={(e) => {
                  props.onHectares?.(e.target.value);
                }}
              />
            </div>
          </div>
          <div className="row">
            <div className="col-6">
              <Typography>Estimated yield</Typography>
            </div>
            <div className="col-6">
              <TextField
                className="input"
                placeholder="Enter yield"
                variant="outlined"
                fullWidth
                value={props.estimatedYield}
                onChange={(e) => props.onEstimatedYield?.(e.target.value)}
              />
            </div>
          </div>
          <div className="row">
            <div className="col-6">
              <Typography>Irrigation</Typography>
            </div>
            <div className="col-6">
              <Select
                value={props.irrigation?.id}
                placeholder="Select service"
                fullWidth
                variant="outlined"
                style={{height: 40}}
              >
                {[
                  {
                    id: 'IRRIGATED',
                    name: 'Irrigated',
                  },
                  {
                    id: 'DRYLAND',
                    name: 'Dryland',
                  },
                  {
                    id: 'BOTH',
                    name: 'Mixed',
                  },
                ].map((preference) => (
                  <MenuItem
                    key={preference.id}
                    value={preference.id}
                    onClick={() => props.onIrrigation?.(preference)}
                  >
                    {preference.name}
                  </MenuItem>
                ))}
              </Select>
            </div>
          </div>
          <div className="row">
            <div className="col-6">
              <Typography>Plant date</Typography>
            </div>
            <div className="col-6">
              <KeyboardDatePicker
                autoOk
                variant="inline"
                inputVariant="outlined"
                label="Start Date"
                format="DD/MM/yyyy"
                // onChange={(date) => setStartDate(date)}
                value={props.startDate}
                onChange={(date) => props.onStartDate?.(date as any)}
                className={'date-picker'}
                fullWidth
              />
            </div>
          </div>
          <div className="row">
            <div className="col-6">
              <Typography>Est. Supply Date</Typography>
            </div>
            <div className="col-6">
              <KeyboardDatePicker
                autoOk
                variant="inline"
                inputVariant="outlined"
                label="Supply Date"
                format="DD/MM/yyyy"
                value={props.supplyDate}
                onChange={(date) => props.onSupplyDate?.(date as any)}
                className={'date-picker'}
                fullWidth
              />
            </div>
          </div>
          {farmFields.length > 0 && !props.includeFundingInfo && (
            <>
              <div className="title">Farm fields (optional)</div>
              {selectedFarmFields.map((field) => (
                <div className="row" key={field.id}>
                  <div className="col-6">{field.info.fieldName}</div>
                  <div className="col-6">
                    <FontAwesomeIcon
                      icon={faTrash}
                      className="pointer"
                      onClick={() =>
                        setSelectedFarmFields(
                          selectedFarmFields.filter((f) => f.id !== field.id),
                        )
                      }
                    />
                  </div>
                </div>
              ))}
              {selectedFarmFields.length !== farmFields.length && (
                <div className="row">
                  <div className="col-6"></div>
                  <div className="col-6">
                    <ButtonAddFees
                      title="Add field"
                      options={
                        farmFields?.map((field) => ({
                          name: field.info.fieldName,
                          ...field,
                        })) || []
                      }
                      selectedOptions={selectedFarmFields}
                      onSelect={(field) => {
                        setSelectedFarmFields([...selectedFarmFields, field]);
                      }}
                    />
                  </div>
                </div>
              )}
            </>
          )}
        </>
      </MuiPickersUtilsProvider>
    </div>
  );
};

export default ProductionPlan;
